<template src="./Profile.html" />

<script>
import { useStore } from "@/store/store.js"
import ListClinics from "../Clinic/ListClinics/ListClinics.vue";
import mixins from "../../../../../Mixins.js";
import WholeMultiselect from "@/components/whole-multiselect/WholeMultiselect.vue";
export default {
  components: {
    ListClinics,
    WholeMultiselect
  },
  mixins: [mixins],
  data() {
    return {
      window: {
        width: 0,
        height: 0
      },
      invalidFields: {
        name: false,
        cpf: false,
        birthdate: false,
        cellPhone: false,
        graduation: false,
        yearGraduation: false,
        workplace: false,
        crmNumber: false,
        email: false,
        zipcode: false,
        street: false,
        number: false,
        city: false,
        state: false,
      },
      saveClicked: false,
      validateForm: false,
      showTabs: true,
      clickedPhoto: false,
      indexActive: 0,
      personalData: [],
      showProfile: true,
      showClinic: false,
      files: [],
      name: "",
      birthdate: null,
      cellPhone: "",
      contactCellPhone: false,
      contactEmail: false,
      contactSecretary: false,
      contactWhatsApp: false,
      cpf: "",
      crmNumber: null,
      crmState: "",
      imageData: "",
      documentData: "",
      phone: "",
      email: "",
      specialtiesAdd: [],
      specialties: [],
      user: [],
      gender: null,
      genderOptions: [
        { text: "Feminino", value: "FEMALE" },
        { text: "Masculino", value: "MALE" }
      ],
      msgResposta: "",
      address: {
        zipcode: "",
        city: "",
        complement: "",
        number: "",
        state: "",
        street: "",
        neighborhood: ""
      },
      disableAddress: {
        city: false,
        state: false,
        street: false
      },
      graduation: "",
      workplace: "",
      yearGraduation: "",
    };
  },
  setup () {
    const store = useStore()

    return {
      getAddressByZipcode: (cep) => store.dispatch("getAddressByZipcode", cep),
    }
  },
  created() {
    const vm = this;
    window.addEventListener("resize", vm.handleResize);
    vm.handleResize();
  },
  destroyed() {
    const vm = this;
    window.removeEventListener("resize", vm.handleResize);
  },
  mounted() {
    const vm = this;
    vm.init();
  },
  watch: {
    name: function(newVal) {
      const vm = this;
      vm.invalidFields.name = vm.testNullUndefinedEmpty(newVal) && vm.saveClicked;
    },
    cpf: function(newVal) {
      const vm = this;
      vm.invalidFields.cpf = !vm.validateCPF(newVal) && vm.saveClicked;
    },
    cellPhone: function(newVal) {
      const vm = this;
      vm.invalidFields.cellPhone = vm.testNullUndefinedEmpty(newVal) && vm.saveClicked;
    },
    graduation: function(newVal) {
      const vm = this;
      vm.invalidFields.graduation = vm.testNullUndefinedEmpty(newVal) && vm.saveClicked;
    },
    yearGraduation: function(newVal) {
      const vm = this;
      vm.invalidFields.yearGraduation = newVal && !vm.validateYearGraduation(newVal) && vm.saveClicked;
    },
    workplace: function(newVal) {
      const vm = this;
      vm.invalidFieldsworkplace = vm.testNullUndefinedEmpty(newVal) && vm.saveClicked;
    },
    crmNumber: function(newVal) {
      const vm = this;
      vm.invalidFields.crmNumber = vm.testNullUndefinedEmpty(newVal) && vm.saveClicked;
    },
    email: function(newVal) {
      const vm = this;
      vm.invalidFields.email = !vm.validateEmail(newVal) && vm.saveClicked;
    },
    'address.zipcode': function(newVal) {
      const vm = this;
      vm.invalidFields.zipcode = vm.testNullUndefinedEmpty(newVal) && vm.saveClicked;
    },
    'address.street': function(newVal) {
      const vm = this;
      vm.invalidFields.street = vm.testNullUndefinedEmpty(newVal) && vm.saveClicked;
    },
    'address.number': function(newVal) {
      const vm = this;
      vm.invalidFields.number = vm.testNullUndefinedEmpty(newVal) && vm.saveClicked;
    },
    'address.city': function(newVal) {
      const vm = this;
      vm.invalidFields.city = vm.testNullUndefinedEmpty(newVal) && vm.saveClicked;
    },
    'address.state': function(newVal) {
      const vm = this;
      vm.invalidFields.state = vm.testNullUndefinedEmpty(newVal) && vm.saveClicked;
    }
  },
  methods: {
    init() {
      const vm = this;
      vm.addSpecialty();
      vm.getSpecialties();
      vm.getPersonalData();
    },
    handleResize() {
      const vm = this;
      vm.window.width = window.innerWidth;
      vm.window.height = window.innerHeight;
      if (vm.window.width <= 670) {
        vm.showTabs = false;
      } else {
        vm.showTabs = true;
      }
    },
    clickShowProfile() {
      const vm = this;
      vm.showProfile = true;
    },
    clickShowClinics() {
      const vm = this;
      vm.showProfile = false;
    },
    resetValidation() {
      const vm = this;
      vm.validateForm = true;
      vm.invalidFields = {
        name: false,
        cpf: false,
        birthdate: false,
        cellPhone: false,
        graduation: false,
        yearGraduation: false,
        workplace: false,
        crmNumber: false,
        email: false,
        zipcode: false,
        street: false,
        number: false,
        city: false,
        state: false
      };
    },
    checkFields() {
      const vm = this;
      var isInvalid = this.invalidFields;
      if (vm.saveClicked) {
        isInvalid.name = vm.testNullUndefinedEmpty(vm.name);
        isInvalid.cpf = !vm.validateCPF(vm.cpf);
        isInvalid.cellPhone = vm.testNullUndefinedEmpty(vm.cellPhone);
        isInvalid.crmNumber = vm.testNullUndefinedEmpty(vm.crmNumber);
        isInvalid.email = !vm.validateEmail(vm.email);
        isInvalid.street = vm.testNullUndefinedEmpty(vm.address.street);
        isInvalid.number = vm.testNullUndefinedEmpty(vm.address.number);
        isInvalid.city = vm.testNullUndefinedEmpty(vm.address.city);
        isInvalid.state = vm.testNullUndefinedEmpty(vm.address.state);

        return !(
          isInvalid.name ||
          isInvalid.cpf ||
          isInvalid.cellPhone ||
          isInvalid.crmNumber ||
          isInvalid.email ||
          isInvalid.zipcode ||
          isInvalid.street ||
          isInvalid.number ||
          isInvalid.city ||
          isInvalid.state
        );
      }
    },
    async getAddressDataAndCheckFields(isToSave) {
      if (this.address.zipcode) {
        const response = await this.getAddressByZipcode(this.address.zipcode)
        this.invalidFields.zipcode = !response || !response.address

        if (!this.invalidFields.zipcode) {
          this.address.city = response.address.city
          this.address.state = response.address.state
          this.address.street = response.address.street
          this.address.neighborhood = response.address.neighborhood

          if (!isToSave) {
            this.address.number = ""
          }
        } else {
          this.address.city = ""
          this.address.street = ""
          this.address.state = ""
          this.address.number = ""
          this.address.complement = ""
          this.address.neighborhood = ""
        }
      }

      this.disableAddress.street = !!this.address.street
      this.disableAddress.city = !!this.address.city
      this.disableAddress.state = !!this.address.state

      if(isToSave) {
        this.putPersonalData(this.checkFields());
      } else {
        this.checkFields();
      }
    },
    savePersonalData() {
      const vm = this;
      vm.resetValidation();
      vm.saveClicked = true;
      vm.getAddressDataAndCheckFields(true);
    },
    putPersonalData(validForm) {
      const vm = this;

      if (validForm) {
        var doctorData = {
          id: vm.personalData.id,
          address: vm.address,
          birthdate: vm.birthdate,
          cellPhone: vm.cellPhone,
          contactCellPhone: vm.contactCellPhone,
          contactEmail: vm.contactEmail,
          contactSecretary: vm.contactSecretary,
          contactWhatsApp: vm.contactWhatsApp,
          cpf: vm.cpf,
          crmNumber: vm.crmNumber,
          crmState: vm.crmState,
          documents: vm.files,
          email: vm.email,
          gender: vm.testNullUndefinedEmpty(vm.gender)? null : vm.gender.value,
          graduation: vm.graduation,
          graduationRequired: vm.personalData.graduationRequired,
          hasValidContaAZulCustumerId:
            vm.personalData.hasValidContaAZulCustumerId,
          janssenProgram: vm.personalData.janssenProgram,
          name: vm.name,
          numberAdvice: null,
          phone: vm.phone,
          specialties:
            typeof vm.specialtiesAdd[0].name === "undefined"
              ? null
              : vm.specialtiesAdd,
          status: vm.personalData.status,
          tempEmail: null,
          workplace: vm.workplace,
          yearGraduation: vm.yearGraduation
        };
        vm.axios
          .put(
            vm.$store.state.filooServer + "doctor/personal-data",
            doctorData,
            {
              headers: { Authorization: vm.$session.get("bearer") }
            }
          )
          .then(function(response) {
            if (response.status === 200) {
              sessionStorage.setItem("save_order", true);
              vm.$swal({
                title: "Sucesso!",
                text: "Dados salvos com sucesso",
                icon: "success"
              }).then(function() {
                location.reload();
              });
            }
          })
          .catch(function(error) {
            var erro = error.data.message;
            if (erro === "exception.user.already.exist.email") {
              vm.$vs.notify({
                title: "Atenção!",
                text:
                  "E-mail já utilizado, verifique se o profissional já possui cadastro ou digite um novo e-mail",
                color: "warning",
                position: "top-right",
                icon: "error",
                time: 6000
              });
              vm.invalidFields.email = true;
            }
            if (erro === "exception.user.already.exist.CPF") {
              vm.$vs.notify({
                title: "Atenção!",
                text:
                  "CPF já utilizado, verifique se o profissional já possui cadastro ou digite um novo CPF",
                color: "warning",
                position: "top-right",
                icon: "error",
                time: 6000
              });
              vm.invalidFields.cpf = true;
            }
          });
      } else {
        let temp = vm.name;
        vm.name = "";
        vm.name = temp;
        vm.$vs.notify({
          title: "Ops..",
          text: "Campos obrigatórios não preenchidos ou inválidos.",
          color: "warning",
          position: "top-right",
          align: "left",
          icon: "error",
          time: 3000
        });
      }
    },
    addFile(e) {
      const vm = this;
      let droppedFiles = e.dataTransfer.files;
      let doUpload = false;
      var extAllowed = ["jpg", "pdf"];
      if (!droppedFiles) return;
      [...droppedFiles].forEach(f => {
        if (f.size > 10000000) {
          vm.$vs.notify({
            title: "Atenção!",
            text:
              'O arquivo "' +
              f.name +
              '" ultrapassou o tamanho permitido de 10MB!',
            color: "warning",
            icon: "error",
            position: "top-right"
          });

          return (doUpload = false);
        }
        var extFile = f.name.split(".").pop();
        if (
          typeof extAllowed.find(function(ext) {
            return extFile == ext;
          }) == "undefined"
        ) {
          vm.$vs.notify({
            title: "Atenção!",
            text:
              "O arquivo " +
              f.name +
              ' possui extensão "' +
              extFile +
              '" não permitida!',
            color: "warning",
            icon: "error",
            position: "top-right"
          });

          return (doUpload = false);
        } else {
          doUpload = true;
          vm.files.push(f);
        }
      });

      if (droppedFiles.length > 0 && doUpload === true) {
        for (var i = 0; i < droppedFiles.length; i++) {
          let file = droppedFiles[i];

          const formData = new FormData();

          formData.append("file", file);
          vm.axios
            .post(
              vm.$store.state.filooServer + "doctor/documents/upload",
              formData,
              {
                headers: { Authorization: vm.$session.get("bearer") },
                "Content-Type": "multipart/form-data"
              }
            )
            .then(function(response) {
              if (response.status === 200) {
                vm.getPersonalData();
              }
            });
        }
      }
    },
    clickAddFile: function(e) {
      const vm = this;
      var input = e.target;

      var extAllowed = ["jpg", "pdf"];

      var extFile = input.value.split(".").pop();

      if (input.files[0].size > 10000000) {
        vm.$vs.notify({
          title: "Atenção!",
          text:
            'O arquivo "' +
            input.files[0].name +
            '" ultrapassou o tamanho permitido de 10MB!',
          color: "warning",
          icon: "error",
          position: "top-right"
        });
      }
      if (
        typeof extAllowed.find(function(ext) {
          return extFile == ext;
        }) == "undefined"
      ) {
        vm.$vs.notify({
          title: "Atenção!",
          text: 'Extensão "' + extFile + '" não permitida!',
          color: "warning",
          icon: "error",
          position: "top-right"
        });
      } else {
        if (input.files && input.files[0]) {
          var reader = new FileReader();

          reader.onload = e => {
            vm.documentData = e.target.result;
          };

          reader.readAsDataURL(input.files[0]);

          const formData = new FormData();
          formData.append("file", input.files[0], input.files[0].name);

          vm.axios
            .post(
              vm.$store.state.filooServer + "doctor/documents/upload",
              formData,
              {
                headers: { Authorization: vm.$session.get("bearer") },
                "Content-Type": "multipart/form-data"
              }
            )
            .then(function(response) {
              if (response.status === 200) {
                vm.getPersonalData();
              }
            });
        }
      }
    },
    downloadFile(file) {
      const vm = this;
      vm.axios
        .get(
          vm.$store.state.filooServer +
            "doctor/documents/" +
            file.id +
            "/download/" +
            file.name,
          {
            headers: { Authorization: vm.$session.get("bearer") },
            responseType: "arraybuffer"
          }
        )
        .then(function(response) {
          if (response.status === 200) {
            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement("a");
            link.href = url;
            link.setAttribute("download", file.name);
            document.body.appendChild(link);
            link.click();
          }
        });
    },
    removeFile(file) {
      const vm = this;
      vm.axios
        .delete(vm.$store.state.filooServer + "doctor/documents/" + file.id, {
          headers: { Authorization: vm.$session.get("bearer") }
        })
        .then(function(response) {
          if (response.status === 200) {
            vm.files = vm.files.filter(f => {
              return f != file;
            });
            vm.getPersonalData();
          }
        });
    },
    previewImage: function(event) {
      const vm = this;

      var input = event.target;

      if (input.files && input.files[0]) {
        var reader = new FileReader();

        reader.onload = e => {
          this.imageData = e.target.result;
        };

        reader.readAsDataURL(input.files[0]);

        const formData = new FormData();

        formData.append("file", input.files[0], input.files[0].name);

        vm.axios
          .post(
            vm.$store.state.filooServer + "/doctor/photo/upload",
            formData,
            {
              headers: { Authorization: vm.$session.get("bearer") },
              "Content-Type": "multipart/form-data"
            }
          )
          .then(function(response) {
            if (response.status === 200) {
              vm.getMe();
            }
          });
      }
    },
    getMe() {
      const vm = this;
      this.axios
        .get(vm.$store.state.filooServer + "me", {
          headers: { Authorization: vm.$session.get("bearer") }
        })
        .then(function(response) {
          vm.options = response.data;
          vm.$session.set("name", vm.options.name);
          vm.$session.set("photo", vm.options.photo);
          vm.$session.set("crmState", vm.options.crmState);
          vm.$session.set("crmNumber", vm.options.crmNumber);
          if (vm.options.type === "DOCTOR") {
            vm.$session.set("type", "Doctor");
          }
        });
    },
    getPersonalData() {
      const vm = this;
      vm.axios
        .get(vm.$store.state.filooServer + "doctor/personal-data", {
          headers: { Authorization: vm.$session.get("bearer") }
        })
        .then(function(response) {
          if (response.status === 200) {
            vm.personalData = response.data;
            vm.fillPersonalData(response.data);
            vm.fillSpecialties(response.data.specialties);
            vm.files = response.data.documents;
          }
        });
    },
    fillSpecialties(specialties) {
      const vm = this;
      var i = 0;

      for (i = 0; i < specialties.length; i++) {
        vm.specialtiesAdd[i] = specialties[i];
        vm.specialties[i] = specialties[i];
      }
    },
    fillPersonalData(personalData) {
      const vm = this;
      vm.name = personalData.name;
      vm.cpf = vm.maskCpf(personalData.cpf);
      vm.birthdate = personalData.birthdate;
      vm.gender = vm.genderOptions.find(g => {return g.value === personalData.gender });
      vm.contactCellPhone = personalData.contactCellPhone;
      vm.contactEmail = personalData.contactEmail;
      vm.contactSecretary = personalData.contactSecretary;
      vm.contactWhatsApp = personalData.contactWhatsApp;
      vm.cellPhone = personalData.cellPhone;
      vm.phone = personalData.phone;
      vm.email = personalData.email;
      vm.address = personalData.address;
      vm.address.zipcode = vm.testNullUndefinedEmpty(vm.address.zipcode)
        ? ""
        : vm.maskZipcode(vm.address.zipcode);
      vm.graduation = personalData.graduation;
      vm.yearGraduation = personalData.yearGraduation;
      vm.workplace = personalData.workplace;
      vm.crmNumber = personalData.crmNumber;
      vm.crmState = personalData.crmState;

      if (!vm.testNullUndefinedEmpty(personalData.id)) {
        vm.saveClicked = true;
        vm.checkFields();
      }

      vm.disableAddress.street = !vm.testNullUndefinedEmpty(vm.address.street);
      vm.disableAddress.city   = !vm.testNullUndefinedEmpty(vm.address.city);
      vm.disableAddress.state  = !vm.testNullUndefinedEmpty(vm.address.state);
    },
    getSpecialties() {
      const vm = this;
      vm.axios
        .get(vm.$store.state.filooServer + "specialties", {
          headers: { Authorization: vm.$session.get("bearer") }
        })
        .then(function(response) {
          if (response.status === 200) {
            vm.specialties = response.data;
          }
        });
    },
    addSpecialty() {
      const vm = this;
      vm.specialtiesAdd.push({});
    },
    removeSpecialty(index) {
      const vm = this;
      vm.specialtiesAdd.splice(index, 1);
    },
    validateFieldsDoctor() {
      const vm = this;
      let validFields = true;
      vm.invalidFields = {
        name: false,
        cpf: false,
        cellPhone: false,
        crmNumber: false,
      };

      if (vm.testNullUndefinedEmpty(vm.name)) {
        vm.invalidFields.name = true;
        validFields = false;
      }

      if (vm.testNullUndefinedEmpty(vm.crmNumber)) {
        vm.invalidFields.crmNumber = true;
        validFields = false;
      }

      if (vm.testNullUndefinedEmpty(vm.cellPhone)) {
        vm.invalidFields.cellPhone = true;
        validFields = false;
      }

      if (validFields === true) {
          vm.savePersonalData();
      } else {
        vm.$vs.notify({
          title: "Ops..",
          text:
            "Campo(s) obrigatório(s) não preenchido(s) ou inválido(s)",
          color: "warning",
          position: "top-right",
          icon: "error",
          time: 3000
        });
      }
    },
  }
};
</script>
<style lang="scss" src="./Profile.scss"></style>
